<div class="tag">
  <span aria-hidden="true" class="ng-value-icon left" (click)="onClose()">×</span>
  <span>{{ tag.title }}</span>
</div>
